import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { defaultMetaObj, initialSalesState } from "store/constants";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";

const { salesEndPoint } = endPoints;

export const fetchAllSales = createAsyncThunk(
  "sales/fetchAllSales",
  async (
    {
      page,
      limit,
      searchParamsObj = {},
    }: { page: number; limit?: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      limit,
      endpoint: salesEndPoint,
      searchParams: { ...searchParamsObj },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSale = createAsyncThunk(
  "sales/deleteSale",
  async ({ saleId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(salesEndPoint, saleId);

      if (response.status === 204) {
        NotificationManager.success("Sale Record Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const salesSlice = createSlice({
  name: "sales",
  initialState: initialSalesState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all sales
    builder
      .addCase(
        fetchAllSales.pending,
        (state: any, action: PayloadAction<any>) => {
          state.loading = true;
        }
      )
      .addCase(
        fetchAllSales.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.sales = action.payload?.objects as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllSales.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.sales = [];
          state.meta = defaultMetaObj;
        }
      );

    // delete Sales
    builder
      .addCase(deleteSale.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSale.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
      })
      .addCase(
        deleteSale.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const salesSliceReducer = salesSlice.reducer;
